<template>
  <el-dialog :title="title"
             :visible.sync="visible"
             width="400px"
             append-to-body
             @closed="handleClose"
             :close-on-press-escape="false">
    <el-form :model="ruleForm"
             :rules="rules"
             ref="ruleForm"
             label-width="90px">
      <el-form-item label="菜单名称:"
                    prop="menuName">
        <el-input :maxlength="8"
                  v-model="ruleForm.menuName"></el-input>
      </el-form-item>
      <el-form-item label="功能名称:"
                    v-if="ruleForm.funcId != null"
                    prop="funcName">
        {{ ruleForm.funcName || '功能名称' }}
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button type="primary"
                 @click="handleSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
export default {
  name: 'menu-node-modal',
  props: {
    callback: { type: Function }
  },
  data () {
    return {
      visible: false,
      ruleForm: { funcId: null, menuId: null, menuName: '', funcName: '' },
      rules: {
        menuName: [{ required: true, message: '请输入菜单名称', trigger: 'blur' }]
      }
    }
  },
  computed: {
    title ({ ruleForm }) {
      return (ruleForm.menuId ? '编辑' : '新增') + '菜单信息'
    }
  },
  methods: {
    handleClose () {
      // this.$refs.ruleForm.resetFields()
      this.ruleForm = { ...this.ruleForm, funcId: null, menuId: null, menuName: '', funcName: '' }
    },
    handleSubmit () {
      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          this.callback && this.callback(this.ruleForm)
          this.visible = false
        }
      })
    },
    init (options = {}) {
      this.ruleForm = { ...this.ruleForm, ...options }
      this.visible = true
    }
  }
}
</script>
